"use strict";

PF.Field.Date = class Date extends PF.Field.String
	{
	static get options()
		{
		return {
			minDate: undefined,
			maxDate: undefined,
			html: PF.Field.Date.templates,
			tooltipConfig: {
				shift: [
					[20, 0],
					[12, 0],
					[-12, 0],
					[-12, 0]
				]
			},
			bottomPanelConfig: {
				steps: [
					'0px', '380px'
				],
			},
			label: 'Выберите дату',
			calendarConfig: {
				dayClass: PF.Field.Date.Day
			},
			errors: {
				incorrectValue: 'Некорректное значение'
			}
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			calendarContainerTooltip: `
			 <div class="pf-date-tooltip-calendar"></div>
			`,
			//language=HTML
			containerBottom: `
			 <div>
				 <div class="container-bottom">
					 <div class="container-bottom-title">Выберите дату:</div>
					 <div class="container-bottom-group">
						 <button pf="containerBottomCopy" class="button-date button button-fill button-round color-gray" title="Копировать"><i class="material-icons">content_copy</i></button>
						 <button pf="containerBottomPaste" class="button-date button button-fill button-round color-blue" title="Вставить"><i class="material-icons">content_paste</i></button>
						 <button pf="containerBottomClear" class="button-date button button-fill button-round color-yellow" title="Очистить"><i class="material-icons">backspace</i></button>
						 <button pf="containerBottomClose" class="button-date button button-fill button-round color-red" title="Отмена"><i class="material-icons">clear</i></button>
					 </div>
				 </div>
				 <div pf="calendarContainerBottom"></div>
			 </div>
			`,
		};
		}

	init()
		{
		super.init();

		if (PF.H.isBigScreen())
			{
			this.dom.calendarContainer = this.dom.calendarContainerTooltip;
			this.popup = new PF.Popup.Tooltip({
				dom: {
					content: this.dom.calendarContainerTooltip,
					anchor: this.dom.wrapper,
				},
				...this.tooltipConfig,
			});
			this.popup.dom.popup.addClass('pf-date-tooltip');

			this.dom.input.onValue('focus', true, () => {
				this.popup.open();
				this.popup.once('opened', () => this.dom.input.focus = true);
			});
			}
		else
			{
			this.dom.calendarContainer = this.dom.calendarContainerBottom;
			this.popup = new PF.BottomPanel({
				dom: {
					container: app.dom.app,
					content: this.dom.containerBottom,
					// touch: this.list.dom.header,
				},
				...this.bottomPanelConfig
			});
			this.dom.input.node.setAttribute('readonly', 'readonly');
			this.dom.input.on('click', () => {
				this.popup.open();
				this.popup.once('opened', () => this.dom.input.focus = true);
			});

			//------------------------------
			// отправить в кэш
			this.dom.containerBottomCopy.on('click', () => {
				let inputValue = this.dom.input.value;
				if (inputValue)
					{
					navigator.clipboard.writeText(inputValue)
						.then(() => {
							console.log('Secess');
						})
						.catch(err => {
							console.log('Something went wrong', err);
						});
					}
			});
			// вставить из кэша
			this.dom.containerBottomPaste.on('click', () => {
				navigator.clipboard.readText()
					.then(text => {
						console.log(text);
						this.model.setData(this.key, this.calcRealValue(text));
					})
					.catch(err => {
						console.log('Something went wrong', err);
					});
			});
			// закрыть
			let inputOldValue = this.dom.input.value;
			this.dom.containerBottomClose.on('click', () => {
				this.model.setData(this.key, this.calcRealValue(inputOldValue));
				this.popup.close();
			});
			// очистить
			this.dom.containerBottomClear.on('click', () => {
				this.model.setData(this.key, null);
			});
			//------------------------------
			}
		this.calendar = new PF.Calendar({
			dom: {
				element: this.dom.calendarContainer,
			},
			field: this,
			...this.calendarConfig,
		});


		this.popup.on('opened', () => {
			this.calendar.rebuild(DateTime.local());
		});

		this.calc('showInfo', ['error', 'popup.state'], (e, s) => {
			return (s !== 'open' && s !== 'opening') || ((s === 'open' || s === 'opening') && e !== '');
		});

		// this.dom.input.onValue('focus', false, () => this.popup.close());

		this.model.onChange(this.key, () => {
			this.setSelected(this.calendar.findDay(this.model.get(this.key)));
		});

		}

	setSelected(day)
		{
		if (this.selected !== undefined)
			{
			this.selected.selected = false;
			}

		if (day === undefined)
			{
			if (this.model.get(this.key, null) !== null)
				{
				this.calendar.rebuild(Util.fromDbDate(this.model.get(this.key)));
				}
			return;
			}

		this.selected = day;
		this.selected.selected = true;
		this.model.setData(this.key, Util.toDbDate(this.selected.model.day));
		// if (this.popup.state === 'open')
		// 	{
		// 	this.calendar.scrollToDay(day);
		// 	}
		}

	bindInput()
		{
		this.on('model.change:' + this.key, () => {
			this.dom.input.value = this.calcDisplayValue(this.model.get(this.key, null, null));
			this.validate(true);
		}, true);
		this.on('dom.input.change:value', () => {
			this.dom.input.value = this.mediateDisplayValue(this.dom.input.value);
			this.model.setData(this.key, this.calcRealValue(this.dom.input.value));
		});
		}

	mediateDisplayValue(displayValue)
		{
		return displayValue;
		}

	calcDisplayValue(realValue)
		{
		if (realValue === null)
			{
			return this.dom.input.value;
			}
		return Util.toLocalDate(realValue);
		}

	calcRealValue(displayValue)
		{
		let val = Util.toDbDate(displayValue, null);
		return val;
		}

	validate(silent, error)
		{
		let val = Util.toDbDate(this.dom.input.value, null);
		if (val === null && this.dom.input.value.length > 0)
			{
			return super.validate(false, this.errors.incorrectValue, true);
			}


		return super.validate(silent, error);
		}

	};


PF.Field.Date.Day = class DateDay extends PF.Calendar.Day
	{

	onRender()
		{
		super.onRender();
		this.field = this.list.calendar.field;

		this.dom.item.on('click', () => {
			this.field.setSelected(this);
		});

		this.bindDom({item: 'class:selected'}, 'selected');

		if (this.field.model.get(this.field.key, null) !== null)
			{
			if (this.model.day.hasSame(Util.fromDbDate(this.field.model.get(this.field.key, null)), 'day'))
				{
				this.selected = true;
				this.list.calendar.field.selected = this;
				}
			}
		}


	};